import React, { useState, useEffect } from 'react'

import { ContentBanner } from './style'
import Button from '../../components/CustomButton'
import ModalCookies from '../ModalCookies'

const BannerCookies = () => {
    const initialCookieSettings = JSON.parse(localStorage.getItem('cookiePreferences')) || {
        cookie1: false,
        cookie2: false,
        cookie3: false
    }
    const [showBanner, setShowBanner] = useState(true)
    const [showSettingsModal, setShowSettingsModal] = useState(false)
    const [cookieSettings, setCookieSettings] = useState(initialCookieSettings)
    useEffect(() => {
        if (!initialCookieSettings) {
            setShowBanner(true)
        } else if (Object.values(initialCookieSettings).some((value) => value === true)) {
            setShowBanner(false)
        }
    }, [])
    const acceptCookies = () => {
        setCookieSettings((prevSettings) => ({
            ...prevSettings,
            cookie1: true,
            cookie2: true,
            cookie3: true
        }))

        setShowBanner(false)
    }
    useEffect(() => {
        localStorage.setItem('cookiePreferences', JSON.stringify(cookieSettings))
    }, [cookieSettings])

    const openSettingsModal = () => {
        setShowSettingsModal(true)
    }

    const closeSettingsModal = () => {
        setShowSettingsModal(false)
    }
    return (
        <>
            {showBanner && (
                <ContentBanner>
                    <div className="cookie-info">
                        Este sitio utiliza mecanismos de seguimiento de sitios web para poder operar
                        adecuadamente, también utilizamos cookies por parte de terceros para mejorar
                        continuamente nuestros servicios y para mostrar anuncios de acuerdo al
                        interés del usuario. Política de privacidad y uso de cookies.
                    </div>
                    <div className="cookie-content-btns">
                        <Button
                            type="button"
                            onClick={acceptCookies}
                            buttonType="primary"
                            size="lg"
                            category="default"
                            fontSize="10px"
                            textAlign="center"
                        >
                            Aceptar cookies
                        </Button>
                        <Button
                            type="button"
                            onClick={openSettingsModal}
                            buttonType="tertiary"
                            size="lg"
                            category="default"
                            fontSize="10px"
                            textAlign="center"
                        >
                            Configuración de cookies
                        </Button>
                    </div>
                </ContentBanner>
            )}
            <ModalCookies
                isOpen={showSettingsModal}
                onClose={closeSettingsModal}
                setShowBanner={setShowBanner}
            />
        </>
    )
}
export default BannerCookies
